import React, { useRef } from "react";
import { useCreateSimplyKioskoContext } from "../provider/createSimplyKiosko.provider";
import PrimaryButton from "../../../../../components/buttons/PrimaryButton";
import { useCreatePurchaseAgents } from "../../../../../services/microservice/agents/purchase/use-purchase-agents";
import { useKioskoConfig } from "../../../context/kiosko-config.context";

const PaymentComponent = () => {
  const config = useKioskoConfig();
  const { formData, infoPayment, setStep, setInfoPayment } =
    useCreateSimplyKioskoContext();
  const { mutateAsync: createPurchaseAgent, isLoading } =
    useCreatePurchaseAgents();
  const submittingRef = useRef(false);

  const selectedOption = formData?.plan?.pricingOptions?.find(
    (opt: any) => opt.id === formData?.priceOptionId,
  );

  const mapIntervalToUnit = (interval: string): "month" | "day" | "year" => {
    const intervalMap: Record<string, "month" | "day" | "year"> = {
      MENSUAL: "month",
      ANUAL: "year",
      SEMANAL: "day",
      SEMESTRAL: "month",
      QUINCENAL: "day",
      BIENAL: "year",
    };
    return intervalMap[interval.toUpperCase()] || "month";
  };

  const mapIntervalToCount = (interval: string): number => {
    const intervalCountMap: Record<string, number> = {
      MENSUAL: 1,
      ANUAL: 1,
      SEMANAL: 1,
      SEMESTRAL: 6,
      QUINCENAL: 2,
      BIENAL: 2,
    };
    return intervalCountMap[interval.toUpperCase()] || 1;
  };

  const handleNextStep = async () => {
    if (submittingRef.current) return;
    submittingRef.current = true;
    const amountString = (formData?.valuePolicie || "")
      .replaceAll("$", "")
      .replaceAll(",", "")
      .replaceAll(" ", "");
    const frequency = selectedOption?.paymentFrequency || "MENSUAL";
    try {
      const data = {
        amount: Number(amountString) || 0,
        taxes: 0,
        interval: mapIntervalToUnit(frequency),
        intervalCount: mapIntervalToCount(frequency),
        planName: `PR${amountString}`,
        planDescription: `PR${amountString}`,
        // "otro dispositivo" (appliances) no tiene imei: se usa el serial
        // como identificador para la pasarela de pago.
        device: {
          imei: formData?.imei || formData?.serial || "",
          line: "0000000000",
        },
        client: {
          name: formData?.name || "",
          email: formData?.email || "",
          identification: {
            number: formData?.numberDocument || "",
            type: formData?.typeDocument || "",
          },
        },
        sponsorID: config.sponsorID,
        pregeneratePolicyId: infoPayment?.pregeneratePolicyId || "",
      };
      const res = await createPurchaseAgent(data);
      if (res) {
        setInfoPayment({ ...infoPayment, checkout: { ...res.data } });
        setStep((prev) => prev + 1);
      }
    } catch (error) {
      console.log(error);
    } finally {
      submittingRef.current = false;
    }
  };

  const handlePreviousStep = () => {
    setStep(1);
  };

  return (
    <section className="w-full space-y-6 p-6">
      <h2 className="mb-5 text-center text-3xl font-bold">
        <span>Pago</span>
      </h2>
      <div className="rounded-2xl border-2 border-gray bg-white p-4 shadow-sm">
        <h2 className="mb-3 text-lg font-semibold">Datos cliente</h2>
        <dl className="grid grid-cols-1 gap-x-6 gap-y-2 sm:grid-cols-2">
          <div>
            <dt className="text-gray-500 text-sm">Nombre completo</dt>
            <dd className="font-medium">{formData?.name}</dd>
          </div>
          <div>
            <dt className="text-gray-500 text-sm">Tipo de documento</dt>
            <dd className="font-medium">{formData?.typeDocument}</dd>
          </div>
          <div>
            <dt className="text-gray-500 text-sm">Número de documento</dt>
            <dd className="font-medium">{formData?.numberDocument}</dd>
          </div>
          <div>
            <dt className="text-gray-500 text-sm">Email</dt>
            <dd className="font-medium">{formData?.email}</dd>
          </div>
        </dl>
      </div>
      <div className="rounded-2xl border-2 border-gray bg-white p-4 shadow-sm">
        <h2 className="mb-3 text-lg font-semibold">Datos del plan</h2>
        <dl className="grid grid-cols-1 gap-x-6 gap-y-2 sm:grid-cols-2">
          <div>
            <dt className="text-gray-500 text-sm">Nombre del plan</dt>
            <dd className="font-medium">{formData?.plan?.name}</dd>
          </div>
          <div>
            <dt className="text-gray-500 text-sm">
              Valor de cobertura IVA incluido
            </dt>
            <dd className="font-medium">
              $
              {selectedOption?.paymentAmountWithTaxes
                ?.toString()
                .replaceAll(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,")}
            </dd>
          </div>
          <div>
            <dt className="text-gray-500 text-sm">Frecuencia de pago</dt>
            <dd className="font-medium">{selectedOption?.paymentFrequency}</dd>
          </div>
        </dl>
      </div>
      <div className="mt-5 flex w-full justify-between">
        <PrimaryButton
          title="Atrás"
          type="button"
          className={"mt-5 rounded-3xl border px-5 py-1 text-textBlack"}
          style={{ borderColor: "#0a0a0a" }}
          onClick={() => handlePreviousStep()}
        />
        <PrimaryButton
          title="Ir al pago"
          className={
            "mt-5 rounded-3xl bg-buttonBlack px-5 py-1 text-sm font-normal text-whiteSoft"
          }
          onClick={handleNextStep}
          loading={isLoading}
          disabled={isLoading}
          type="button"
        />
      </div>
    </section>
  );
};

export default PaymentComponent;
